// extracted by mini-css-extract-plugin
module.exports = {"container":"FollowedLoads_container__UmSMd","header":"FollowedLoads_header__FLeAk","links":"FollowedLoads_links__iadnA","links_newTab":"FollowedLoads_links_newTab__amuCn"};